import { useSelector } from 'react-redux'
import { actorNames } from '../../../../commonComponents/utils'
import usePdiEnable from '../../../hooks/usePdiEnable'

export const Broker = ({ renderForm }) => {
  const dataSource = useSelector((state) => state.Actor.broker)
  const pdiDisabled = usePdiEnable();
  const disableFields = {name:true,eoriNo:true,addressLine1:true,addressLine2:true,city:true,state:true,postalCode:true,country:true,rep:false}
  if(Object.keys(pdiDisabled).length !== 0){
    pdiDisabled.disableFields = disableFields;
  }
  return renderForm
    ? renderForm({
        actorType: 'broker',
        boxNumber: '14',
        ...pdiDisabled,
        displayREP: true,
        actorName: actorNames.brokerName,
        dataSource: dataSource,
      })
    : null
}
